export default {
    oauth: {
        url: 'https://oauth-abe.dev.pixellot.tv',
        clientId: 'cms-internal',
        redirectUrl: 'http://localhost:3000',
    },
};
